/*
 * @Author: fengyanjing
 * @Date: 2020-06-02 14:05:28
 * @Description:
 * @FilePath: /frontend/src/components/rebate/comp-rebate-layout-one/index.js
 */
import UserInfo from '@/components/rebate/user-info/index.vue';
import MonthPicker from '@/components/rebate/month-picker/index.vue';
import ActivityPicker from '@/components/rebate/activity-picker/index.vue';
import SystemPicker from '@/components/rebate/system-picker/index.vue';
import Rmb from '@/components/common/rmb/index.vue';
import RebateTable from '@/components/rebate/rebate-table/index.vue';
import IndexTabbar from '@/components/common/index-tabbar/index.vue';

export default {
    name: 'CompRebateLayoutOne',
    components: {
        UserInfo,
        MonthPicker,
        ActivityPicker,
        SystemPicker,
        Rmb,
        RebateTable,
        IndexTabbar,
    },
    model: {
        prop: 'selectedDate',
        event: 'onSelectedDateChange',
    },
    props: {
        userInfo: {
            required: true,
            type: Object,
            default: () => {
                return {
                    userName: '吴亦凡',
                    level: '股东',
                    avatar: 'http://pics.sc.chinaz.com/files/pic/pic9/201509/apic14546.jpg',
                };
            },
        },
        minDate: {
            required: false,
            default: () => new Date(2023, 4), // 最小日期：2020-04
        },
        selectedDate: {
            //  当前日期选择器选中的时间
            required: true,
            default: () => new Date(),
        },
        showTabbar: {
            type: Boolean,
            default: false,
        },
        selectedActivity: {
            required: true,
            default: () => {},
        },
        selectedSystem: {
            required: true,
            default: () => {},
        },
        activityList: {
            required: true,
            default: () => [],
        }
    },
    methods: {
        //  选中的日期发生了变化
        changeSelectedDate(value) {
            this.$emit('onSelectedDateChange', value);
        },

        //  点击了折扣发放管理按钮
        onClickRebateBtn() {
            this.$emit('clickRebateBtn');
        },

        changeSelectedActivity(value) {
            this.$emit('onSelectedActivityChange', value);
        },

        changeSelectedSystem(value) {
            this.$emit('onSelectedSystemChange', value);
        },
    },
};
